import OfficeAsyncError from './OfficeAsyncError';

export default function getEmlBlob(): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const item = Office.context.mailbox?.item;

    if (!item) {
      return reject(new Error('No email selected'));
    }

    if (typeof item.getAsFileAsync !== 'function') {
      return reject(
        new Error('getAsFileAsync is not available on this Outlook host'),
      );
    }

    item.getAsFileAsync((result) => {
      if (result.status === Office.AsyncResultStatus.Failed) {
        return reject(
          new OfficeAsyncError(result.error, 'Failed to get email as file'),
        );
      }

      // result.value is a base64-encoded string of the EML content
      const base64Content = result.value;
      const binaryString = atob(base64Content);
      const bytes = new Uint8Array(binaryString.length);

      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const blob = new Blob([bytes], { type: 'message/rfc822' });

      resolve(blob);
    });
  });
}
